import {
  COLOR_BLACK,
  COLOR_BUTTON_PRIMARY,
  COLOR_RED,
} from '@hilbi/web-common/assets/styles/colors';
import styled, { css } from 'styled-components';
import { TPropsSC } from './button';

export function getPropsForLoader(variant: TPropsSC['kind'], size: TPropsSC['size']) {
  let result = {
    variant: 'on-dark',
    size: 'small',
  };

  switch (variant) {
    case 'PRIMARY':
    case 'DANGER':
      result = { ...result, variant: 'on-dark' };
      break;
    case 'SECONDARY':
    case 'LINK':
      result = { ...result, variant: 'on-light' };
      break;
    default:
      break;
  }

  switch (size) {
    case 'LG':
      result = { ...result, size: 'medium' };
      break;
    case 'MD':
    case 'SM':
      result = { ...result, size: 'small' };
      break;
    default:
      break;
  }

  return result;
}

export const ButtonSC = styled.button<TPropsSC & { $loading?: boolean }>`
  position: relative;
  overflow: hidden;

  border: none;
  cursor: pointer;
  transition: 0.2s all;

  .button-content {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    white-space: nowrap;
    line-height: 1;
    visibility: ${({ $loading }) => ($loading ? 'hidden' : 'visible')};
  }

  margin-bottom: ${({ mb }) => (mb ? `${mb}px` : '0')};
  margin-top: ${({ mt }) => (mt ? `${mt}px` : '0')};

  &:hover,
  &:focus {
    text-decoration: none;
    outline: none;
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .loader {
    position: absolute;
    inset: 0;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  ${({ size, shape }) => {
    if (size === 'SM') {
      return `
        padding: 0 26px;
        height: 24px;
        border-radius: 5px;
        ${
          shape === 'round'
            ? css`
                width: 24px;
                height: 24px;
                border-radius: 12px;
                padding: 2px;
              `
            : ''
        }
      `;
    } else if (size === 'NM') {
      return `
        padding: 0 26px;
        height: 30px;
        border-radius: 5px;
        ${
          shape === 'round'
            ? css`
                width: 30px;
                height: 30px;
                border-radius: 15px;
                padding: 13px;
              `
            : ''
        }
      `;
    } else if (size === 'MD') {
      return `
        padding: 0 30px;
        height: 40px;
        border-radius: 10px;
        ${
          shape === 'round'
            ? css`
                width: 40px;
                height: 40px;
                border-radius: 20px;
                padding: 15px;
              `
            : ''
        }
      `;
    }

    return `
      padding: 0 24px;
      height: 50px;
      border-radius: 10px;
      ${
        shape === 'round'
          ? css`
              width: 50px;
              height: 50px;
              border-radius: 25px;
              padding: 12px;
            `
          : ''
      }
    `;
  }}

  ${({ isBlock }) => {
    if (isBlock) {
      return css`
        display: block;
        width: 100%;

        .button-content {
          display: block;
          width: 100%;
        }
      `;
    }
  }}

  ${({ kind }) => {
    if (kind === 'PRIMARY') {
      return `
        color: #fff;
        background: ${COLOR_BUTTON_PRIMARY};
        box-shadow: 0 0 15px 0 rgba(106, 213, 229, 0.45);
      `;
    } else if (kind === 'DANGER') {
      return `
        color: #fff;
        background: ${COLOR_RED};
        box-shadow: 0 0 15px 0 rgba(255, 51, 92, 0.5);
      `;
    } else if (kind === 'LINK') {
      return `
      color: ${COLOR_BLACK};
      background: transparent;

      &:hover{
        text-decoration: underline;
      }

    `;
    }
    return `
      color: #323D6F;
      background: #eaebf0;
    `;
  }}
`;
